import React, { useCallback, useEffect, useState } from "react";
import "../../App.css";
import { Inspection } from "../../components/Inspection/Inspection";
import elabAPI from "../../libs/api/elab";
import { baseUrl, isLocalHosted } from "../../libs/env";
import Error from "../../erros/Error";
import { useHistory } from "react-router-dom";
import { CustomOriginProvider } from "../../components/custom_origin/CustomOriginContext";
import ElabAssessment from "./elab_assessment/ElabAssessment";

export const getQuizId = () => {
  let id = window.location.pathname.split("/")[3];
  return id;
};

const TestScreen = (props) => {

  const [items, setItems] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSystemRedirection, setIsSystemRedirection] = useState(false);

  let history = useHistory();
  if (isLocalHosted === false) {
    Inspection();
  }
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    setTimeout(() => {
      elabAPI
      .get({ id: getQuizId() })
      .then((res) => res.json())
      .then((json) => {
        setIsLoaded(true);
        setItems(json);
      })
      .catch((error) => console.log(error.message));
    }, 50);
  }, []);
  

  const submitQuiz = useCallback(
    (data, redirection) => {
      if (data.is_submit) {
        setIsSubmitting(true);
        elabAPI
          .post({ id: getQuizId(), data })
          .then((res) => res.json())
          .then((json) => {
            setIsSubmitting(false);
            setIsLoaded(true);
            if (!redirection) {
              setItems(json);
              scrollTop();
            }

            if (json.message === "Already submitted.") {
              localStorage.clear();
              setIsSystemRedirection(true);
              window.location.replace(
                `${baseUrl}/elab/practice-tests/?task_completed=true`
              );
            }

            if (json.is_show_feedback === false) {
              setIsSystemRedirection(true);
              history.push("/stagging");
            }
          });
      } else {
        elabAPI
          .post({ id: getQuizId(), data })
          .then((res) => res.json())
          .then((json) => {
            if (redirection) {
              setIsSystemRedirection(true);
              window.location.replace(
                `${baseUrl}/elab/practice-tests/`
              );
            }
          });
      }
    },
    [history]
  );

  if (!isLoaded) {
    return (
      <div className={`centered text-light fs-4`}>
        <div class="spinner-border h-w-100" role="status"></div>
      </div>
    )
  }
  return (
    <>
      {items.detail ? (
        <Error data={items} isLoaded={isLoaded} />
      ) : (
        <CustomOriginProvider userSource={items ? items.user_source: null}>
        <ElabAssessment
          setIsSystemRedirection={setIsSystemRedirection}
          isSystemRedirection={isSystemRedirection}
          data={items}
          isLoaded={isLoaded}
          onSubmit={submitQuiz}
          isSubmitting={isSubmitting}
        />
        </CustomOriginProvider>
      )}
    </>
  );
};

export default TestScreen;
